{
  "el": {
    "ticket_category": {
      "Decisions": "Απόφαση",
      "Issue": "Παρατήρηση",
      "Regular": "Κανονική",
      "labels": {
        "ticket_category": "Τύπος"
      }
    }
  }
}
